var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFirebaseinline = function SvgFirebaseinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA000",
    d: "M2.285 12.449 4.135.299a.336.336 0 0 1 .392-.29.36.36 0 0 1 .247.185l1.91 3.664.759-1.49a.334.334 0 0 1 .46-.15.4.4 0 0 1 .145.15l5.149 10.08z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F57C00",
    d: "M8.67 7.714 6.684 3.848l-4.399 8.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFCA28",
    d: "m13.197 12.448-1.415-9.003a.346.346 0 0 0-.393-.29.33.33 0 0 0-.187.097l-8.917 9.196 4.936 2.85c.307.175.69.175.997 0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.2,
    d: "M11.795 3.454a.346.346 0 0 0-.392-.29.33.33 0 0 0-.188.097L9.442 5.084l-1.39-2.726a.334.334 0 0 0-.46-.149.4.4 0 0 0-.145.149l-.759 1.49L4.78.184a.333.333 0 0 0-.46-.14.36.36 0 0 0-.18.254l-1.85 12.15h-.008l.009.009.05.026 7.102-7.311 1.773-1.823c.136-.14.35-.14.486 0a.32.32 0 0 1 .094.192l1.398 8.916.017-.009zM2.307 12.43 4.14.386a.336.336 0 0 1 .392-.29.36.36 0 0 1 .247.184l1.91 3.665.758-1.49a.334.334 0 0 1 .46-.15.4.4 0 0 1 .145.15l1.364 2.664z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#A52714",
    d: "M8.218 15.21c-.307.175-.69.175-.997 0l-4.927-2.84-.009.078 4.936 2.85c.307.174.69.174.997 0l4.979-2.85-.009-.079z",
    opacity: 0.2
  })));
};
export default SvgFirebaseinline;